import { useAppContextStore } from '@src/contexts/AppContextStore'
import { IS_SSR } from '@src/lib/server-side-rendering'
import { useEffect, useState } from 'react'
import { Fade, RevealProps } from 'react-awesome-reveal'

export const FadeRevealWithSSR = (props: RevealProps & any) => {
  const { contextStore } = useAppContextStore()
  const [mounted, setMounted] = useState(contextStore.get('APP_IS_MOUNTED'))

  useEffect(() => {
    setMounted(true)
  }, [])

  if (IS_SSR || !mounted) {
    return props.children
  } else {
    return <Fade {...props}>{props.children}</Fade>
  }
}
